
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitojyotilinga() {



    const cardData =
    {
        keyword: 'Mumbai to 5 Jyotirlinga Cab ',
        heading: 'Skyline Cabs:  Mumbai to 5 Jyotirlinga Cab ',
        headingDescription: 'Skyline Cabs offers a spiritual and comfortable Mumbai to 5 Jyotirlinga Cab service, perfect for devotees seeking a divine pilgrimage experience. Our well-maintained cabs and experienced drivers ensure a safe, smooth, and convenient journey as you visit the sacred Jyotirlingas—Trimbakeshwar, Bhimashankar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Enjoy flexible travel plans, transparent pricing, and 24/7 customer support for a worry-free religious tour. Book your Mumbai to 5 Jyotirlinga cab with Skyline Cabs today and embark on a blessed journey with complete peace of mind.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Mumbai to 5 Jyotirlinga Cab",
      "description": "Skyline Cabs offers a dedicated cab service for the Mumbai to 5 Jyotirlinga pilgrimage. Travel across sacred temples like Trimbakeshwar, Bhimashankar, Aundha Nagnath, Parli Vaijnath, and Grishneshwar in comfort with professional drivers and clean, spacious vehicles."
    },
    {
      "name": "Mumbai to Jyotirlinga Darshan Taxi",
      "description": "Plan your divine journey to the revered Jyotirlingas with Skyline Cabs. Our Jyotirlinga darshan taxi service ensures a peaceful and well-managed trip with customizable routes and vehicle options based on your needs."
    },
    {
      "name": "Jyotirlinga Temple Tour from Mumbai",
      "description": "Experience a spiritual road trip from Mumbai to all major Jyotirlinga temples with our all-inclusive taxi packages. Our drivers are familiar with temple routes and timings, ensuring a smooth, timely darshan experience."
    },
    {
      "name": "Mumbai to 5 Jyotirlinga Tour Package",
      "description": "Skyline Cabs provides specially curated 3 to 5-day Jyotirlinga tour packages from Mumbai. Cover all 5 major temples with a fixed itinerary, experienced chauffeurs, hotel tie-ups, and guided travel support."
    },
    {
      "name": "Jyotirlinga Darshan Taxi Service",
      "description": "Our taxi service for Jyotirlinga darshan is tailored for spiritual seekers. Enjoy a seamless travel experience with well-maintained cabs, pre-planned temple visits, and 24/7 customer assistance."
    },
    {
      "name": "5 Jyotirlinga One Way Cab",
      "description": "Book one-way cab rides to individual Jyotirlingas from Mumbai with Skyline Cabs. Choose destinations like Bhimashankar or Trimbakeshwar and travel at your convenience with economical one-way pricing."
    },
    {
      "name": "Taxi for Jyotirlinga Darshan",
      "description": "Skyline Cabs offers reliable taxis for Jyotirlinga darshan from Mumbai. Choose from sedans, SUVs, or tempo travelers depending on your group size, and enjoy a spiritual journey without any travel stress."
    }
  ],
  "tableData": [
    ["Mumbai to 5 Jyotirlinga Cab", "Mumbai to Jyotirlinga Darshan Taxi"],
    ["Jyotirlinga Temple Tour from Mumbai", "Mumbai to 5 Jyotirlinga Tour Package"],
    ["Jyotirlinga Darshan Taxi Service", "5 Jyotirlinga One Way Cab"],
    ["Taxi for Jyotirlinga Darshan", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai to 5 Jyotirlinga Cab Service",
        "WhyChoosedescription": "Embark on a spiritual journey with our reliable Mumbai to 5 Jyotirlinga cab service. Enjoy a smooth, comfortable ride while visiting these sacred temples across Maharashtra."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Cabs",
        "WhyChoosedescription": "Our cabs are designed for comfort, with spacious interiors that ensure a relaxed and enjoyable journey as you travel between the 5 Jyotirlinga temples."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer competitive pricing for the Mumbai to 5 Jyotirlinga tour, with no hidden charges. Enjoy a budget-friendly pilgrimage trip with upfront pricing."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced, knowledgeable about the best routes, and committed to your safety. They ensure a smooth and comfortable journey to each of the Jyotirlinga temples."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "All our vehicles are regularly serviced, thoroughly cleaned, and sanitized to ensure a safe, hygienic, and comfortable ride throughout your pilgrimage."
    },
    {
        "WhyChooseheading": "Flexible Travel Options",
        "WhyChoosedescription": "Choose from flexible packages for your Mumbai to 5 Jyotirlinga trip, whether you prefer a one-day journey or extended travel, we tailor the experience to suit your needs."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Booking your Mumbai to 5 Jyotirlinga cab is easy with 24/7 customer support. You can book online or over the phone, with instant confirmation and a seamless booking experience."
    },
    {
        "WhyChooseheading": "Ideal for Spiritual and Group Travel",
        "WhyChoosedescription": "Our cabs are perfect for solo pilgrims, family groups, or friends traveling together to visit the 5 Jyotirlingas. The spacious and comfortable vehicles ensure a pleasant journey for everyone."
    }
]













    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to the 5 Jyotirlinga temples with Skyline Cabs?',
            answer:
                'You can book a cab from Mumbai to cover the 5 Jyotirlinga temples through our website, mobile app, or by calling our customer support. Select your preferred vehicle, choose the "Jyotirlinga Darshan" package, and confirm your itinerary and travel dates.',
        },
        {
            id: 2,
            question: 'Which Jyotirlingas are included in the Mumbai to 5 Jyotirlinga cab package?',
            answer:
                'Our 5 Jyotirlinga cab package from Mumbai typically covers Bhimashankar, Trimbakeshwar (Nashik), Grishneshwar (Aurangabad), Aundha Nagnath (Hingoli), and Parli Vaijnath (Beed). Custom routes can also be arranged.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for this religious trip?',
            answer:
                'We offer a range of vehicles such as Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and Tempo Travellers to accommodate all group sizes. Choose according to your comfort and budget.',
        },
        {
            id: 4,
            question: 'Are there fixed tour packages or can I customize my Jyotirlinga tour?',
            answer:
                'Yes, we offer both fixed itinerary packages and customizable options. You can choose the temples, dates, and duration as per your convenience.',
        },
        {
            id: 5,
            question: 'Is the pricing for the 5 Jyotirlinga cab service fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing. The fare includes vehicle rental, driver charges, tolls, taxes, and parking. No hidden fees.',
        },
        {
            id: 6,
            question: 'Are overnight stays and stopovers included in the package?',
            answer:
                'Yes, multi-day packages include recommended stopovers and accommodations can be arranged upon request. You can also plan your own stay and we’ll align the travel accordingly.',
        },
        {
            id: 7,
            question: 'Are the cabs safe and drivers experienced for long temple tours?',
            answer:
                'Absolutely. Our cabs are well-maintained and sanitized. Drivers are experienced, familiar with temple routes, and trained to ensure a smooth and spiritual journey.',
        },
        {
            id: 8,
            question: 'What payment options are available for this package?',
            answer:
                'You can pay via UPI, credit/debit cards, net banking, or cash. All payments are secure, and part payments can be made at the time of booking.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule the Jyotirlinga tour?',
            answer:
                'Yes, Skyline Cabs offers flexible cancellation and rescheduling options. You can modify your itinerary through our app, website, or customer care.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the 5 Jyotirlinga tour from Mumbai?',
            answer:
                'Skyline Cabs is trusted for long religious journeys. We offer reliable service, clean vehicles, knowledgeable drivers, and 24/7 support—making your sacred trip comfortable and spiritually fulfilling.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Our family’s Jyotirlinga yatra from Mumbai was beautifully managed by Skyline Cabs. The driver was well-versed with temple timings and routes. Truly a peaceful experience!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Booked the 5 Jyotirlinga cab from Mumbai with Skyline. It was a comfortable journey, and everything was taken care of. Highly recommend them for religious travel!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to 5 Jyotirlinga Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-5-jyotirlinga-cab.jpg",
  "description": "Book Mumbai to 5 Jyotirlinga Cab with Skyline Cabs for a sacred and comfortable pilgrimage. Travel to Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath in AC sedans, SUVs, or tempo travellers with expert drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8223"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12500",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-5-jyotirlinga-cab"
  }
};


      
     
      


    return (
        <div>

<Helmet>
  <title>Mumbai to 5 Jyotirlinga Cab | Darshan Tour Package | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to 5 Jyotirlinga Cab with Skyline Cabs for a sacred and comfortable pilgrimage. Travel to Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath in AC sedans, SUVs, or tempo travellers with expert drivers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to 5 Jyotirlinga Cab, 5 Jyotirlinga Darshan from Mumbai, Jyotirlinga Tour Package Mumbai, Mumbai to Jyotirlinga Taxi, Jyotirlinga Yatra Cab, AC Cab for Jyotirlinga Darshan, SUV for Jyotirlinga Trip Mumbai, Skyline Cabs Jyotirlinga Tour" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/80.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitojyotilinga;